module.exports = __webpack_public_path__ + "img/btn-info.be52553d.svg";